module.exports = __webpack_public_path__ + "static/media/fair.58baa585.svg";